<div class="wrapper wrap" *ngIf="addressLookupUnavailable">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="pageTitle">
          <span *ngIf="!serviceUnavailableContent.title">Address lookup currently unavailable</span>
        </h1>
      </div>
    </div>
  </div>
</div>